module.exports = __webpack_public_path__ + "static/media/Vector2.3842b71c.svg";